module.exports = __webpack_public_path__ + "img/medicina.72357987.jpg";